export const SET_CAPITALIZATION_OF_EARNINGS = "SET_CAPITALIZATION_OF_EARNINGS"